import { TemplateTypeAndLocalesQueryContextProvider } from './TemplateTypeAndLocalesQueryContextProvider';
import { WhatsAppPreviewContextProvider } from './WhatsAppPreviewContextProvider';
import { WhatsAppSenderContextProvider } from './WhatsAppSenderContextProvider';
import { WhatsAppLinkShorteningContextProvider } from './WhatsAppLinkShorteningContextProvider';

export const WhatsAppContext = ({ children }: { children: React.ReactNode }) => (
  <TemplateTypeAndLocalesQueryContextProvider>
    <WhatsAppSenderContextProvider>
      <WhatsAppLinkShorteningContextProvider>
        <WhatsAppPreviewContextProvider>{children}</WhatsAppPreviewContextProvider>
      </WhatsAppLinkShorteningContextProvider>
    </WhatsAppSenderContextProvider>
  </TemplateTypeAndLocalesQueryContextProvider>
);
